import { connect } from 'react-redux'
import requestAddSubCard from '../../sagas/requestAddSubCard'
import requestAddNewChildCard from 'routes/Board/sagas/requestAddNewChildCard'
import addSubCardSelector from './addSubCardSelector'
import AddSubCard from './AddSubCard'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  addSubCardSelector,
  {
    requestAddSubCard,
    requestAddNewChildCard
  }
)(AddSubCard))
